import { Dayjs } from "dayjs";
import { FC, createContext, Dispatch, ReactNode, SetStateAction, useContext } from "react";

type OrdersListContextType = {
  selectedTab: string;
  dateRange: [Dayjs, Dayjs];
  setDateRange: Dispatch<SetStateAction<[Dayjs, Dayjs]>>;
  navToDetails:(id:string)=>void;
};

const OrdersListContext = createContext<OrdersListContextType | null>(null);

export const OrdersListProvider: FC<{ value: OrdersListContextType; children: ReactNode }> = ({ value, children }) => {
  return <OrdersListContext.Provider value={value}>{children}</OrdersListContext.Provider>;
};

export const useOrdersList = ()=>{
    const context = useContext(OrdersListContext);
    if (!context) throw new Error("Illegal Usage of useOrdersList outside its context");
    return context;
}